import Breadcumb from '../../components/Breadcumb'
import MsgAlert from '../../components/MsgAlert'
import MintForm from './MintForm'
import {
  mintImg,
  badge,
  iconsCelebration
} from "../../utils/allImgs"
import data from '../../data/data-containers/data-MintForm.json'
import SEO from "../../components/Seo"

const MintNFTContainer = () => {

  return (
    <>
      <SEO title="Mint" />
      <main>
        <Breadcumb title='Mint NFT' />
        <MintForm
          data={data[0].bestArtists__header}
          imgMint={mintImg}
          imgBadge={badge}
        />
        <MsgAlert
          img={iconsCelebration}
          title="NFT MINTED SUCCESSFULLY ..."
          text="Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga similique accusantium quae natus odio est ullam ab. Ea iusto corrupti.!"
        />
      </main>
    </>
  );
}

export default MintNFTContainer;